<template>
    <div id="div_wrap">
        <app-header></app-header>
        <div id="div_left">
          <app-bio></app-bio>
        </div>
        <div id="div_right">
          <router-view></router-view>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
// Imports
import bio from './components/bio.vue';
import header from './components/header.vue';
import footer from './components/footer.vue';

export default {
    components: {
        'app-bio': bio,
        'app-header': header,
        'app-footer': footer
    },
    data () {
        return {

        }
    },
    methods: {

    }
}
</script>

<style>
body{
    margin: 0;
    background-color: #666666;
    font-family: 'Nunito SemiBold';
}

#div_wrap {
  max-width: 768px;
  background-color: #ffffff;
	border-radius: 5px;
  margin-left: auto;
  margin-right: auto; 
  padding: 50px;
}
#div_wrap:after { 
  content: " "; 
  display: block;
  clear: both;
} 

#div_left {
  float:left;
  width: 24%;
  text-align: right;
  /* padding: 0 15px 0 0; */
  margin: 5px 15px 0 0;
}

#div_right {
  float:right;
  width: 74%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue